import { FeaturePainter, PaintState } from "@luciad/ria/view/feature/FeaturePainter.js";
import { PointLabelPosition } from "@luciad/ria/view/style/PointLabelPosition.js";
import { PointLabelStyle } from "@luciad/ria/view/style/PointLabelStyle.js";
import { LabelCanvas } from "@luciad/ria/view/style/LabelCanvas.js";
import { IconStyle } from "@luciad/ria/view/style/IconStyle.js";
import { GeoCanvas } from "@luciad/ria/view/style/GeoCanvas.js";
import { Feature } from "@luciad/ria/model/feature/Feature.js";
import { Shape } from "@luciad/ria/shape/Shape.js";
import { Layer } from "@luciad/ria/view/Layer.js";
import { Map } from "@luciad/ria/view/Map.js";
 
export class CityLabelLayerPainter extends FeaturePainter {
  _labelStyle: PointLabelStyle = {
    positions: PointLabelPosition.NORTH
  };

  // Have to be present
  paintBody() { };
  
  // pozor: "labelPaintRepresentation" = true
  paintLabel(labelCanvas: LabelCanvas, feature: Feature, shape: Shape, layer: Layer, map: Map, paintState: PaintState) {
    const label = paintState.selected ? `
            <div class="btn btn-secondary container active">
                  <div class="name">${feature.properties.label}</div>
            </div>` : `<div class="btn btn-secondary container active">
            <div class="name">${feature.properties.label}</div>
      </div>`;
    labelCanvas.drawLabel(label, shape, this._labelStyle);
  }; 
}